module.exports = __webpack_public_path__ + "static/media/christian.7cd6dd34.jpg";